import FreefieldProfileList from "freefieldprofile/list/App";
import FreeFieldProfileDetailApp from "freefieldprofile/detail/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const freeFieldProfileRoute: RouteObject = {
  path: "freefieldprofile",
  children: [{
    path: ":environment",
    loader: () => viewModel,
    Component: FreefieldProfileList,
  }, {
    path: ":environment/detail/:key",
    loader: () => viewModel,
    Component: FreeFieldProfileDetailApp,
  }, {
    path: ":environment/new",
    loader: () => viewModel,
    Component: FreeFieldProfileDetailApp,
  }]
};